<template>
  <section class="defaults">
    <img src="https://cdn.gelonghui.com/webActive/image_emptypage_update.png"
         alt="">
    <p>请更新至最新版本</p>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "rule",
  data () {
    return {
      val: ""
    };
  },
  created () {

  },
  methods: {

  }
};

</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.defaults {
  position: relative;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  img {
    margin-top: 300px;
    width: 250px;
  }

  p {
    margin-top: 16px;
    font-size: 15px;
    text-align: center;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/defaults.vue